export const logClientEvent = (
  message: string,
  meta: Record<string, unknown> = {},
) => {
  fetch('/api/log', {
    method: 'POST',
    body: JSON.stringify({ message, meta }),
    headers: {
      'Content-Type': 'application/json',
    },
  }).catch(e => {
    // Optional: remove this if you don't want console noise
    console.error('Failed to log client event', e)
  })
}
